import { render, staticRenderFns } from "./TabSetPreferences.vue?vue&type=template&id=f9591c6c&scoped=true&"
import script from "./TabSetPreferences.vue?vue&type=script&lang=js&"
export * from "./TabSetPreferences.vue?vue&type=script&lang=js&"
import style0 from "./TabSetPreferences.vue?vue&type=style&index=0&id=f9591c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9591c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCheckbox,VSelect})
